import {HTTP} from "./common";

export const AnalyticsApi = {

    dictionary(query) {
        return HTTP.get(`analytics/get_dictionary/${query ? '?' + query : ''}`).then((response) => {
            return response.data;
        });
    },
    get_reviews(query, config = {}) {
        return HTTP.get(`analytics/get_reviews/${query ? '?' + query : ''}`, config).then((response) => {
            return response.data;
        });
    },
    get_chart(query) {
        return HTTP.get(`analytics/get_chart/${query ? '?' + query : ''}`).then((response) => {
            return response.data;
        });
    },
    download_html(date_from, date_to) {
        return HTTP.get(`analytics/download_html/?date_from=${date_from}&date_to=${date_to}`, {responseType: "blob"}).then(response => {
            return response.data
        })
    },


};


